import { Box, Table, TableContainer, TableHead } from '@mui/material'
import { useState } from 'react'

import { ReactComponent as ArrowOpenDone } from 'assets/arrow_open_logo.svg'
import { IMilkYieldChartResponse } from 'models/IMilkYieldChartTypes'
import moment from 'moment'
import { COLORS } from 'styles/colors'
import { TypographyPrimary14Bold } from 'ui/typography/TypographyPrimary14Bold'
import { MilkYieldHistoryTableBody } from './components/MilkYieldHistoryTableBody'
import { MilkYieldHistoryTableHead } from './components/MilkYieldHistoryTableHead'
import { MilkYieldHistoryItem, ShiftKey } from './components/types'

const formatDate = (timestamp: number | string) => {
	return moment(Number(timestamp)).format('DD.MM.YY')
}
interface MilkYieldHistoryProps {
	data: IMilkYieldChartResponse
}
export function MilkYieldHistory({ data }: MilkYieldHistoryProps) {
	const [openDay, setOpenDay] = useState<string[]>([])
	const [reverse, setReverse] = useState<boolean>(false)
	const [showTable, setShowTable] = useState<boolean>(false)

	const handleOpenDay = (date: string) => {
		setOpenDay(prev =>
			prev.includes(date) ? prev.filter(d => d !== date) : [...prev, date],
		)
	}

	const handleReverseArray = () => setReverse(prev => !prev)

	const history: MilkYieldHistoryItem[] =
		data?.graph?.map(day => ({
			date: formatDate(day.date),
			total: day.sell_milk_sum ?? 0,
			shifts: day.milkings?.map(shift => ({
				time: moment(day.date).format('DD.MM.YYYY HH:mm:ss'),
				shiftKey: shift.period as ShiftKey,
				value: shift.sell_milk_amount ?? 0,
			})),
		})) ?? []

	const visibleElement = reverse ? [...history].reverse() : history

	return (
		<Box display='flex' flexDirection='column' gap='16px'>
			<Box display='flex' flexDirection='row' gap='8px' alignItems='center'>
				<TypographyPrimary14Bold>История изменений</TypographyPrimary14Bold>
				<ArrowOpenDone
					onClick={() => setShowTable(prev => !prev)}
					style={{
						cursor: 'pointer',
						width: '14px',
						transform: showTable ? 'rotate(0deg)' : 'rotate(180deg)',
						transition: 'transform 0.3s',
					}}
				/>
			</Box>

			{showTable && (
				<TableContainer
					sx={{
						maxHeight: 350,
						overflowY: 'auto',
						'&::-webkit-scrollbar': {
							width: '4px',
						},
						'&::-webkit-scrollbar-thumb': {
							backgroundColor: COLORS.icon,
							borderRadius: '4px',
						},
					}}
				>
					<Table>
						<TableHead>
							<MilkYieldHistoryTableHead
								handleReverseArray={handleReverseArray}
							/>
						</TableHead>
						<MilkYieldHistoryTableBody history={visibleElement} />
					</Table>
				</TableContainer>
			)}
		</Box>
	)
}
